import { BreakpointObserver } from '@angular/cdk/layout';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { concatMap } from 'rxjs/operators';
import { DomoticaService } from 'src/app/services/domotica/domotica.service';
import { OfficeDoorStatusDTO } from 'src/app/shared/dto/domotica/officeDoorStatus';

@Component({
  selector: "app-office-door-widget-read-qrcode-dialog",
  templateUrl: "./office-door-widget-read-qrcode-dialog.component.html",
  styleUrls: ["./office-door-widget-read-qrcode-dialog.component.scss"],
})
export class OfficeDoorWidgetReadQrCodeDialogComponent implements OnInit {

  availableDevices: MediaDeviceInfo[];
  selectedDevice: MediaDeviceInfo;
  @ViewChild('scanner') scanner: ZXingScannerComponent;
  barcodeReading: boolean;

  audioOK = new Audio();
  audioKO = new Audio();

  constructor(
    public dialogRef: MatDialogRef<OfficeDoorWidgetReadQrCodeDialogComponent>,
    private breakpointObserver: BreakpointObserver,
    private domoticaService: DomoticaService,
    @Inject(MAT_DIALOG_DATA) public command: string
  ) {
  }

  ngOnInit() {
    this.selectedDevice = null;
    this.barcodeReading = false;
    this.audioOK.src = "../../../../assets/beep.wav";
    this.audioOK.load();
    this.audioKO.src = "../../../../assets/Error.wav";
    this.audioKO.load();
  }

  get isMobile(): boolean {
    return this.breakpointObserver.isMatched('(max-width: 959px)');
  }

  scannerCamerasFound(devices: MediaDeviceInfo[]) {
    navigator.mediaDevices.enumerateDevices().then((mediaDevices) => {
      this.availableDevices = [];
      mediaDevices.forEach((mediaDevice: MediaDeviceInfo) => {
        if (mediaDevice.kind == 'videoinput') {
          this.availableDevices.push(mediaDevice);
        }
      })
    });
  }

  onDeviceChange(value: MediaDeviceInfo) {
    this.selectedDevice = value;
    this.scanner.restart();
  }

  qrcodeReaded(qrcode: string) {
    if (this.barcodeReading) return;

    this.barcodeReading = true;
    if (!qrcode.startsWith("location")) {
      this.qrcodeReadFailed();
    } else {
      this.domoticaService.officeDoorCommandWithLocation(this.command, qrcode)
        .pipe(concatMap(() => this.domoticaService.officeDoorStatus(true)))
        .subscribe(
          (res: OfficeDoorStatusDTO) => {
            this.audioOK.play();
            this.barcodeReading = false;
            this.dialogRef.close(res);
          },
          (err: HttpErrorResponse) => {
            if (err?.status === 409) {
              this.audioKO.play();
              this.barcodeReading = false;
              this.dialogRef.close('COMMAND_IN_PROGRESS');
            } else {
              this.qrcodeReadFailed();
            }
          }
        );
    }
  }

  private qrcodeReadFailed(): void {
    this.audioKO.play();
    this.barcodeReading = false;
    this.dialogRef.close(false);
  }
}
